export const GET_DATA = 'GET_DATA';
export const SET_DATA = 'SET_DATA';

export const GET_VERSION_REQUEST = 'GET_VERSION_REQUEST'
export const GET_VERSION_SUCCESS = 'GET_VERSION_SUCCESS'
